module.exports = __webpack_public_path__ + "media/financial_aid/SLC_top-e4c7a3cc.png";